import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/kassir/website/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/builds/kassir/website/layouts/empty.vue").then(m => m.default || m)),
  widget: defineAsyncComponent(() => import("/builds/kassir/website/layouts/widget.vue").then(m => m.default || m)),
  "svg-sprite": defineAsyncComponent(() => import("#build/svg-sprite.vue").then(m => m.default || m))
}